// Standard library imports
import React, { useContext, useState, useEffect } from 'react';

// Internal module imports
import Table from '../../../components/Table/Table';
import ModalComponent from '../../../components/ModalComponent/ModalComponent';
import { Form, Formik } from 'formik';
import Typography from '../../../components/Typography/Typography';
import { Input, ToggleButton, ToggleButtonWithState } from '../../../components/Inputs/Input';
import { USER_ROLE } from '../../../constants';
import { AuthContext } from '../../../context/AuthContext';
import _, { get as LodashGet } from 'lodash';
import CreateButton from '../../../components/Buttons/CreateButton';
import { SCService } from '../../../services/SCService';
import { LoaderContext } from '../../../context/LoaderContext';
import { START_LOADER, STOP_LOADER } from '../../../constants';
import { toast } from 'react-toastify';
import { CreateGroupValidation } from '../../../validations/SCValidation/TagValidation';
import DeleteModalComponent from '../../../components/DeleteModal/DeleteModal';
import { UilTrash, UilPen } from '@iconscout/react-unicons';
import CustomTooltip from '../../../components/CustomToolTip/CustomTooltip';

// Css module imports
import classes from '../../../styles/Alerts.module.css';
import buttonClasses from '../../../components/Buttons/Button.module.css';
import myClasses from '../../../styles/AllDevices.module.css';
import scClasses from '../SmartCharging.module.css';
import Dropdown from '../../../components/Inputs/Dropdown';

const LIMIT = 15;

const modeOptions = [
    { label: 'Smart Charge', value: 'smartCharge' },
    { label: 'Site Load Management', value: 'siteLoadManagement' },
    { label: 'Load Management & Smart Charge', value: 'loadManagement&smartCharge' }
]

const Groups = ({ updateQueryParams, queryParamsData }) => {
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });

    const { state } = useContext(AuthContext);
    const userRole = LodashGet(state, 'user.userRole');
    const [open, setOpen] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [deleteModal, setDeleteModal] = useState({ status: false, id: true });
    const [skip, setSkip] = useState(0);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    const [signalOption, setSignalOptions] = useState([]);

    const initialValues = {
        name: '',
        address: '',
        installedCapacity: '',
        installedCapacitySignal: '',
        mode: '',
        action: false,
    };
    const [groupFormValue, setGroupFormValue] = useState(initialValues);

    useEffect(() => {
        getAllGroups();
    }, [signalOption]);

    useEffect(() => {
        getSignals()
    }, [])

    const getSignals = () => {
        SCService.GetSignals(
            () => startLoader('getSignal'),
            handleGetSignalSuccess,
            handleError,
            () => stopLoader('getSignal')
        );
    };

    const handleGetSignalSuccess = ({ data }) => {
        const options = data.data?.map((item) => ({ label: item.name, value: item._id }));
        setSignalOptions(options);
    }

    const handleSubmit = (data) => {
        const formData = {
            name: data.name,
            address: data.address,
            installedCapacity: data.installedCapacity,
            installedCapacitySignal: data.installedCapacitySignal,
            mode: data.mode,
            action: data.action,
        };

        if (!['siteLoadManagement', 'loadManagement&smartCharge'].includes(data.mode) && (data.installedCapacity >= 0 || data.installedCapacitySignal)) {
            _.unset(formData, 'installedCapacity');
            _.unset(formData, 'installedCapacitySignal');
        }

        if (data._id) {
            SCService.UpdateGroup(
                data._id,
                formData,
                () => startLoader('updateGroup'),
                () => handleCreateSuccess('Updated'),
                handleError,
                () => stopLoader('updateGroup')
            );
        } else {
            SCService.CreateGroup(
                formData,
                () => startLoader('createGroup'),
                handleCreateSuccess,
                handleError,
                () => stopLoader('createGroup')
            );
        }
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const handleCreateSuccess = (type = 'Created') => {
        getAllGroups();
        setOpen(false);
        toast.success(`Tag Group ${type} Successfully`);
    };

    const getAllGroups = () => {
        SCService.GetAllGroups(
            {
                limit: LIMIT,
                skip,
            },
            () => startLoader('getGroups'),
            handleGetGroupsSuccess,
            handleError,
            () => stopLoader('getGroups')
        );
    };

    const getActions = (item) => {
        return (
            <div className={classes.ActionIcons}>
                <div
                    onClick={() => {
                        setOpen(true);
                        setGroupFormValue(item);
                    }}
                >
                    <CustomTooltip content={'Edit'}>
                        <UilPen className={buttonClasses.ButtonIcon} />
                    </CustomTooltip>
                </div>
                <div onClick={() => setDeleteModal({ status: true, id: item._id })}>
                    <CustomTooltip content={'Delete'}>
                        <UilTrash className={buttonClasses.ButtonIcon} />
                    </CustomTooltip>
                </div>
            </div>
        );
    };

    const handleTagToggleChange = (item, active) => {
        item.action = active;
        handleSubmit(item);
    };

    const getActive = (item) => {
        return (
            <div className={classes.ActionIcons}>
                <ToggleButtonWithState value={item.action} onChange={(e) => handleTagToggleChange(item, e.target.checked)} warpperStyle={{ marginTop: '0' }} />
            </div>
        );
    };

    const handleGetGroupsSuccess = ({ data }) => {
        const { groups, totalCount } = data?.data;
        const processedData = groups?.map((item, index) => {
            const signalId = item.installedCapacitySignal;
            const signalName = signalId ? signalOption.filter((signal) => signal.value === signalId)?.[0]?.label : '--';
            const mode = item.mode ? modeOptions.filter((mode) => mode.value === item.mode)?.[0]?.label : '--';
            return {
                ...item,
                slNo: index + 1 + skip,
                address: (
                    !item.address ? (
                        '--'
                    ) : item.address.length > 30 ? (
                        <CustomTooltip content={item.address}>{item.address.substring(0, 30) + '...'}</CustomTooltip>
                    ) : (
                        item.address
                    )
                ),
                installedCapacity: item.installedCapacity >= 0 ? item.installedCapacity : '--',
                installedCapacitySignal: signalName,
                mode,
                active: getActive(item),
                action: getActions(item),
            };
        });

        setTableData(processedData);
        setTotalCount(_.get(_.head(totalCount), 'totalCount', 0));
    };

    const handleDeleteSuccess = (data, id) => {
        toast.success('Tag Site Deleted!');
        getAllGroups();
    };

    const handleDelete = (id) => {
        SCService.DeleteGroup(
            id,
            () => startLoader('deleteGroup'),
            handleDeleteSuccess,
            handleError,
            () => stopLoader('deleteGroup')
        );
    };

    const handlePageChange = (pageno) => {
        setSkip(LIMIT * pageno);
        setPage(pageno);
    };

    return (
        <div className={classes.Alert}>
            <div className={classes.TableHeadSection}>
                <div className={scClasses.HeadingContainer}>
                    <Typography content="Sites" />
                    <div className={myClasses.TableCount}>
                        Total Count :
                        <span>
                            <Typography size="14" content={totalCount} />
                        </span>
                    </div>
                </div>
                {[USER_ROLE.SUDOER, USER_ROLE.EXPERT].includes(userRole) ? (
                    <div className={classes.CreateButton}>
                        <CreateButton
                            size="medium"
                            text="Create Site"
                            onClick={() => {
                                setOpen(!open);
                                setGroupFormValue(initialValues);
                            }}
                        />
                    </div>
                ) : null}
            </div>

            <Table
                head={[
                    'S. No.',
                    'Name',
                    'Site Id',
                    'Address',
                    'Installed Capacity (MW)',
                    'Installed Capacity Signal',
                    'Mode',
                    [USER_ROLE.SUDOER, USER_ROLE.EXPERT].includes(userRole) ? 'Active' : '',
                    [USER_ROLE.SUDOER, USER_ROLE.EXPERT].includes(userRole) ? 'Action' : '',
                ]}
                keys={[
                    'slNo',
                    'name',
                    '_id',
                    'address',
                    'installedCapacity',
                    'installedCapacitySignal',
                    'mode',
                    [USER_ROLE.SUDOER, USER_ROLE.EXPERT].includes(userRole) ? 'active' : '',
                    [USER_ROLE.SUDOER, USER_ROLE.EXPERT].includes(userRole) ? 'action' : '',
                ]}
                data={tableData}
                page={page}
                Pagination={true}
                limit={LIMIT}
                handlePageChange={handlePageChange}
                totalCount={totalCount}
            />

            <ModalComponent isOpen={open} setOpen={setOpen} onClose={setOpen}>
                <div className={classes.ModalWidth}>
                    <Formik
                        initialValues={groupFormValue}
                        validationSchema={CreateGroupValidation}
                        onSubmit={(val, { resetForm }) => {
                            handleSubmit(val, resetForm);
                        }}
                    >
                        {({ errors, touched, values, isValidating, ...props }) => {
                            return (
                                <Form>
                                    <Typography content={values._id ? "Edit Site" : "Create Site"} />
                                    <div>
                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2 + ' ' + classes.FieldControlGrow}>
                                                <label for="name">
                                                    Name <span className="required">*</span>
                                                </label>
                                                <Input name="name" id="name" />
                                            </div>
                                            <div className={classes.FieldControl2 + ' ' + classes.FieldControlGrow}>
                                                <label for="address">
                                                    Address <span className="required">*</span>
                                                </label>
                                                <Input name="address" id="address" />
                                            </div>
                                        </div>
                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2 + ' ' + classes.FieldControlGrow}>
                                                <label for="mode">Mode<span className="required">*</span></label>
                                                <Dropdown
                                                    name="mode"
                                                    options={modeOptions}
                                                    defaultValue={
                                                        { value: values?.mode }
                                                    }
                                                />
                                            </div>
                                            <div className={classes.FieldControl2 + ' ' + classes.FieldControlGrow}>
                                                <ToggleButton label={'Active'} values={values} name="action" id="action" />
                                            </div>
                                        </div>
                                        {['siteLoadManagement', 'loadManagement&smartCharge'].includes(values?.mode) && (<div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2 + ' ' + classes.FieldControlGrow}>
                                                <label for="installedCapacity">
                                                    Installed Capacity (MW) <span className="required">*</span>
                                                </label>
                                                <Input type="number" name="installedCapacity" id="installedCapacity" />
                                            </div>
                                            <div className={classes.FieldControl2 + ' ' + classes.FieldControlGrow}>
                                                <label for="installedCapacitySignal">Installed Capacity Signal<span className="required">*</span></label>
                                                <Dropdown
                                                    name="installedCapacitySignal"
                                                    options={signalOption}
                                                    defaultValue={
                                                        { value: values?.installedCapacitySignal }
                                                    }
                                                />
                                            </div>
                                        </div>)}
                                        <div className={classes.ButtonContainer}>
                                            <div>
                                                <div
                                                    className="btn-secondary"
                                                    onClick={() => {
                                                        setOpen(false);
                                                    }}
                                                >
                                                    Cancel
                                                </div>
                                            </div>
                                            <div>
                                                <button type="submit" className="btn-primary">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </div>
            </ModalComponent>

            <DeleteModalComponent
                deletefunction={handleDelete}
                opendeleteModal={deleteModal.status}
                setOpenDeleteModal={(status) => setDeleteModal({ id: '', status })}
                deviceId={deleteModal.id}
            ></DeleteModalComponent>
        </div>
    );
};

export default Groups;
